import { render, staticRenderFns } from "./BW.vue?vue&type=template&id=8ff4cec8&scoped=true&"
import script from "./BW.vue?vue&type=script&lang=js&"
export * from "./BW.vue?vue&type=script&lang=js&"
import style0 from "./BW.vue?vue&type=style&index=0&id=8ff4cec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff4cec8",
  null
  
)

export default component.exports